// extracted by css-extract-rspack-plugin
export default {"root":"EntityPickerTabBar_root__P+LGL","inner":"EntityPickerTabBar_inner__DjYbB"};